import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout/layout.js";
import Heading from "../components/heading";
import Subheading from "../components/subheading";
import AboutImage from "../components/about-image";
import ImageWrapper from "../components/image-wrapper";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import SEO from "../components/seo";
export const pageQuery = graphql`
  {
    whatIDo: file(relativePath: { eq: "images/what-i-do.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    skills: file(relativePath: { eq: "images/my-skills.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    forFun: file(relativePath: { eq: "images/what-i-do-for-fun.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="About" keywords={["shlomi cohen", "application", "react"]} mdxType="SEO" />

    <h1>{`About`}</h1>
    <AboutImage mdxType="AboutImage" />
    <Heading text="I'm Shlomi Cohen." mdxType="Heading" />
    <Subheading text="fed developer · technology addict · occasional designer · father and husband" mdxType="Subheading" />
    <ImageWrapper mdxType="ImageWrapper">
  <Img fluid={props.data.whatIDo.childImageSharp.fluid} mdxType="Img" />
    </ImageWrapper>
    <h2>{`What I do`}</h2>
    <p>{`I’m a self-taught programmer, that set a goal to become a frontend developer.
I started this journey in 2017 while I am the father of my three children and
working full time in a non-programming job. I have built several react web
apps for small business, looking at a design I can convert it into an HTML CSS
template with pixel-perfect precision. I always use GIT to track my progress
and files, as well as to collaborate with other developers.`}</p>
    <p>{`Currently, I keep learning and building things in Javascript and React
technologies. I’m looking for a position where I can progress and challenge my
skills. I live in  Yavne, Israel.`}</p>
    <ImageWrapper mdxType="ImageWrapper">
  <Img fluid={props.data.skills.childImageSharp.fluid} mdxType="Img" />
    </ImageWrapper>
    <h2>{`My skills`}</h2>
    <ul>
  <li>HTML / CSS / Javascript</li>
  <li>React</li>
  <li>Redux</li>
  <li>GraphQL</li>
  <li>Bootstrap</li>
  <li>Git</li>
  <li>Gatsby</li>
  <li>REST API</li>
  <li>Next.js</li>
    </ul>
    <ImageWrapper mdxType="ImageWrapper">
  <Img fluid={props.data.forFun.childImageSharp.fluid} mdxType="Img" />
    </ImageWrapper>
    <h2>{`What I do for fun`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Travel . on Saturday's with my family in our beautiful country.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`I like photography and always take a camera with me to picture landscapes views, portraits of my kids and nature.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Cook. I love figuring out new recipes to create tasty meals for my family.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Digital music. it's my favorite music and I like to listen to all the genres of it. `}<a parentName="p" {...{
            "href": "https://www.di.fm/"
          }}>{`https://www.di.fm/`}</a></p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      